export default __webpack_public_path__ + "static/events-dark-b03be30be88b336ce67122d10e5c91e8.png";